module.exports = __webpack_public_path__ + "img/icon12.fad5a0dc.png";